<template>
  <div>
    <div class="side-box__header d-flex justify-content-between align-items-center">
      <div class="atom-back atom-back--gray" @click="$emit('close')">
        <div class="atom-back__inner d-flex align-items-center">
          <img src="@/assets/icons/arrows/arr-gray-left.svg" />
          <span>{{ $t("zpet") }}</span>
        </div>
      </div>
      <div class="d-flex">
        <button v-if="transform.public" class="btn btn-primary" @click="handleCreateCopy">
          <span class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-nova.svg" alt="" />
          </span>
          {{ $t("vytvoritKopii") }}
        </button>
        <button v-else class="btn btn-primary" @click="handleSaveTransform">
          <span class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" alt="" />
          </span>
          {{ $t("ulozit") }}
        </button>
      </div>
    </div>
    <div class="side-box__title">
      <h2>{{ transform.label }}</h2>
    </div>
    <div class="side-box__content">
      <div v-if="error" class="text-danger">
        {{ error }}
      </div>
      <div class="side-box__row d-flex align-items-center mt-3">
        <span class="side-box__content__label">
          {{ $t("nazevTransformacniFunkce") }}
        </span>
        <div
          class="side-box__content__input custom-control__custom-input ml-3"
          :class="{ 'has-error': error && !transform.label }"
        >
          <span v-if="!transform.label" class="placeholder">
            {{ $t("zadejteNazevTransformacniFunkce") }}
          </span>
          <input
            autofocus
            class="w-100"
            maxlength="30"
            minlength="1"
            placeholder=""
            type="text"
            :value="transform.label"
            @change="$emit('change', { field: 'label', value: $event.target.value })"
          />
        </div>
      </div>
      <div class="side-box__row d-flex align-items-center mt-3">
        <span class="side-box__content__label">
          {{ $t("transformacniFunkce") }}
        </span>
        <div class="side-box__content__input custom-control__custom-input ml-3">
          <textarea
            autofocus
            class="p-2 w-100"
            :placeholder="$t('zadejteTransformacniFunkci')"
            :value="transform.definition"
            @change="
              $emit('change', {
                field: 'definition',
                value: $event.target.value
              })
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useProjectStore } from "@/store/modules/project"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"

export default {
  name: "TransformationEditModal",
  emits: ["close", "copied", "error", "saved", "change"],
  props: {
    error: {
      type: String,
      default: ""
    },
    transform: {
      type: Object, // { transformationId: number, label: string, definition: string }
      required: true
    }
  },
  setup() {
    const projectStore = useProjectStore()
    const tfStore = useTransformationFunctionsStore()

    return { projectStore, tfStore }
  },
  computed: {
    transformationFunction() {
      return this.tfStore.detail
    },
    project() {
      return this.projectStore.selectedProject
    }
  },
  methods: {
    setTransformationFunction(data) {
      this.tfStore.setDetail(data)
    },
    createTransformationFunction() {
      return this.tfStore.create()
    },
    getTransformationFunction(id) {
      return this.tfStore.getDetail(id)
    },
    deleteTransformationFunction(id) {
      return this.tfStore.deleteTransformation(id)
    },
    updateTransformationFunction() {
      return this.tfStore.update()
    },
    async handleCreateCopy() {
      try {
        this.setTransformationFunction({
          ...this.transform,
          label: `${this.transform.label} (1)`,
          public: false,
          transformationId: null
        })

        const newId = await this.createTransformationFunction()
        await this.getTransformationFunction(newId)
        this.$emit("copied", this.transformationFunction)
      } catch (error) {
        this.$emit("error", error)
      }
    },
    async handleSaveTransform() {
      if (!this.transform.label && !this.transform.definition) {
        this.errors.transform = this.$t("fillAllFieldsError")
        return
      }

      try {
        this.setTransformationFunction(this.transform)
        await this.updateTransformationFunction()
        await this.getTransformationFunction(this.transform.transformationId)
        this.$emit("saved", this.transformationFunction)
      } catch (error) {
        this.$emit("error", error)
      }
    }
  }
}
</script>
